export const getDefaultState = () => {
  return {
    fromListOrder: null,
    orderListHistory: null,
    couponDetail: null,
    importantPoints: null
  }
}

const state = getDefaultState()
export default state
